<template>
  <div>
    <hrms-search-box-table  v-model="paramSearchDetail"
                            :receivedStore="receivedHres6aeDetailSearch"
                            searchBoxAlias="hres6ae-detail"
                            :columns="columnsDetail"
                            :data="detail.table"
                            :maxRowspan="maxRowspanDetail"
                            :addInlineEventBool="false"
                            :editInlineEventBool="saveButtonDisp"
                            :deleteInlineEventBool="false"
                            :backEvent="backEvent"
                            :saveInlineBtnDisp="saveButtonDisp"
                            :saveInlineEvent="callSave"
                            :columnEvent="columnEvent"
                            :indexDisp="false"
                            :nowLang="nowLang"
                            :rowDisableCondition="rowDisableCondition" />
    <div class="box-footer">
      <button type="button" class="btn bg-color-skin pull-right" data-toggle="modal" data-target="#hres6ae-popup"><i class="fa fa-list-alt"></i> {{ labels['HRES6AEC2']['200'] }}</button>
    </div>

    <popup :labels="labels"
            :detailPopup="detail.popup"
            :columnsDetailPopup="columnsDetailPopup"
            :maxRowspanPopup="maxRowspanPopup" />

  </div>
</template>

<script>
import popup from 'components/hres6ae/popup'
import configLabels from 'src/../config/label'
import swal from 'sweetalert'

export default {
  name: 'hres6ae-detail',
  data () {
    return {
      paramSearchDetail: this.searchDetail
    }
  },
  watch: {
    'searchDetail.dteworkst' () {
      this.paramSearchDetail.dteworkst = this.searchDetail.dteworkst
    },
    'searchDetail.dteworken' () {
      this.paramSearchDetail.dteworken = this.searchDetail.dteworken
    },
    'paramSearchDetail.dteworkst' () {
      this.searchDetail.dteworkst = this.paramSearchDetail.dteworkst
    },
    'paramSearchDetail.dteworken' () {
      this.searchDetail.dteworken = this.paramSearchDetail.dteworken
    },
    indexSelected () {
      this.paramSearchDetail.dteworkst = this.indexSelected.dtework
      this.paramSearchDetail.dteworken = this.indexSelected.dtework
    }
  },
  props: [ 'labels',
    'labelsButton',
    'detail',
    'nowLang',
    'toggle',
    'postHres6aeSave',
    'columnsDetail',
    'columnsDetailPopup',
    'indexSelected',
    'receivedHres6aeDetailSearch',
    'maxRowspanDetail',
    'maxRowspanPopup',
    'searchDetail',
    'searchIndex',
    'saveButtonDisp'
  ],
  methods: {
    backEvent () {
      this.toggle('index')
    },
    columnEvent (eventName, param) {
      if ((eventName === 'dtein' || eventName === 'timin' || eventName === 'dteout' || eventName === 'timout') && param.dtein !== '' && param.dtein !== param.dtein_o) {
        param.timin = param.timin || param.timstrtw
        param.dteout = param.dteout || param.dteendw
        param.timout = param.timout || param.timendw
      }
      this.$nextTick(() => {
        if (param.dtein === param.dtein_o && param.timin === param.timin_o && param.dteout === param.dteout_o && param.timout === param.timout_o && param.codreqst === param.codreqst_o && param.remark === param.remark_o) {
          param.flgEdit = false
        } else {
          param.flgEdit = true
        }
      })
    },
    callSave (dataRowsHasFlg) {
      if (dataRowsHasFlg.length > 0) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.postHres6aeSave({ saveParams: dataRowsHasFlg, searchIndex: this.searchIndex, searchDetail: this.paramSearchDetail })
          }
        })
      } else {
        swal({
          title: '', text: configLabels.msgError[this.nowLang]['noDataHasFlg'], html: true, type: 'success'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      }
    },
    rowDisableCondition (rowsData) {
      return typeof rowsData.flgpayroll !== 'undefined' && rowsData.flgpayroll === 'Y'
    }
  },
  components: {
    popup
  }
}
</script>




// WEBPACK FOOTER //
// detail.vue?752b5c58